import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  makeStyles
} from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import moment from 'moment'
import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from 'src/components/ui/Button'
import { SynRoutes } from 'src/core/consts/synRoutes'
import useAuth from 'src/hooks/useAuth'

const useStyles = makeStyles(theme => ({
  conteudo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  }
}))

function formatarDataLimite(dataLimite?: string | null) {
  if (!dataLimite) return null
  const data = moment(dataLimite)
  if (!data.isValid()) return null
  return data.format('DD/MM/YYYY')
}

export default function AvisoPendenciaBacenDialog() {
  const classes = useStyles()
  const history = useHistory()
  const {
    pendenciaBacen,
    carregandoPendenciaBacen,
    avisoPendenciaBacenDispensado,
    dispensarAvisoPendenciaBacen
  } = useAuth()

  if (carregandoPendenciaBacen || !pendenciaBacen) return null
  if (!pendenciaBacen.temPendencia) return null
  if (pendenciaBacen.bloqueioAtivo) return null
  if (avisoPendenciaBacenDispensado) return null

  const dataFormatada = formatarDataLimite(pendenciaBacen.dataLimite)

  function irParaRegularizacao() {
    dispensarAvisoPendenciaBacen()
    history.push(SynRoutes.regularizacaoBacen)
  }

  return (
    <Dialog
      open
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="aviso-pendencia-bacen-titulo"
    >
      <DialogTitle id="aviso-pendencia-bacen-titulo">
        Atualização cadastral pendente
      </DialogTitle>
      <DialogContent>
        <Box className={classes.conteudo}>
          <Alert severity="warning" variant="outlined">
            Há {pendenciaBacen.total} recebedor(es) com dados incompletos na
            Pagar.me (regra BACEN). Regularize agora para evitar bloqueio de
            recebimentos
            {dataFormatada ? ` a partir de ${dataFormatada}` : ''}.
          </Alert>
          <Typography variant="body2">
            Você pode continuar usando a plataforma e voltar depois. O aviso
            reaparecerá nos próximos logins enquanto a pendência existir.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => dispensarAvisoPendenciaBacen()} color="default">
          Continuar depois
        </Button>
        <Button
          onClick={irParaRegularizacao}
          variant="contained"
          color="primary"
          autoFocus
        >
          Regularizar agora
        </Button>
      </DialogActions>
    </Dialog>
  )
}
